import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MenuItem } from "@/types/menu.type";
import SidebarComponent from "./SidebarComponent.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const items: MenuItem[] = [
  {
    icon: "el-icon el-icon-home fas",
    index: "/admin",
    title: "menu.home",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-map-marker fas",
    index: "/admin/stations",
    title: "menu.stations",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-box fas",
    index: "/admin/containers",
    title: "menu.containers",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye fas",
    index: "/admin/samplingPoints",
    title: "menu.samplingPoints",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-user fas",
    index: "/admin/users",
    title: "menu.users",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-eye-dropper fas",
    index: "/admin/parameters",
    title: "menu.parameters",
    disabled: false,
  },
  {
    icon: "el-icon el-icon-database fas",
    index: "/admin/opendata",
    title: "menu.opendata",
    subs: [
      {
        icon: "",
        index: "/admin/saica",
        title: "menu.saica",
        disabled: false,
      },
      {
        icon: "",
        index: "/admin/saih",
        title: "menu.saih",
        disabled: false,
      },
      {
        icon: "",
        index: "/admin/aemet",
        title: "menu.aemet",
        disabled: false,
      },
    ],
    disabled: false,
  },
  {
    icon: "el-icon el-icon-upload fas",
    index: "/admin/upload",
    title: "menu.uploaderData",
    disabled: false,
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SidebarComponent, { items: items }))
}
}

})